module.exports = __webpack_public_path__ + "static/media/20200810_111024.2d601fc9.webp";